import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './components/search/search.component';
import { AppIconModule } from '@common/modules/icon';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SearchComponent],
  imports: [CommonModule, AppIconModule, ReactiveFormsModule],
  exports: [SearchComponent],
})
export class SearchModule {}
